import React from "react";
import User from "../../../assets/images/CT/user.png";
import CurrentPlayer from "../../../assets/images/CT/current_player.png";
import dash from "../../../assets/images/CT/dash.png";
import Cross from "../../../assets/images/CT/cross.png";
import Speaker from "../../../assets/images/CT/speaker.png";
import ScoreDots from "../../../assets/images/CT/score-dots.png";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withSocket } from "../../../socket/context";
import aliens from "../../../assets/images/CT/aliens.png";
import tech from "../../../assets/images/CT/tech.png";
import mythos from "../../../assets/images/CT/mythos.png";
import random from "../../../assets/images/CT/random.png";
import schemes from "../../../assets/images/CT/schemes.png";
import _ from "lodash";

const set_image = (card_type) => {
  switch (card_type) {
    case "tech":
      return <img src={tech}></img>;
      break;
    case "aliens":
      return <img src={aliens}></img>;
      break;
    case "mythos":
      return <img src={mythos}></img>;
      break;
    case "random":
      return <img src={random}></img>;
      break;
    case "schemes":
      return <img src={schemes}></img>;
      break;
  }
};
const card = ["tech", "aliens", "schemes", "mythos", "random"];
const CTLeftContent = (props) => {
  const roomData = _.get(props, "gameReducer.roomObj");
  const reader = _.get(roomData, "game_state.reader");
  const active_player = _.get(roomData, "game_state.active_player");
  const player_status = _.get(roomData, "game_state.player_status");
  const active_player_cards = _.find(player_status, {
    id: active_player,
  })?.cards;
  const playingParams = _.get(props, "paramsReducer.gameObj.2_playing");
  const categoryParams = _.get(props, "paramsReducer.gameObj.category");
  const allPlayers = _.get(roomData, "users");
  const { colours } = props;
  const player_queue = _.get(roomData, "game_state.player_queue");

  const render_score_dots = (user) => {
    const player_cards = _.find(player_status, { id: user.player_id })?.cards;
    return (
      player_cards &&
      Object.keys(player_cards).map((card_type) => {
        if (player_cards[card_type] === 0) {
          return (
            <div className="score_type_container">
              <img src={dash} alt="" className="dash-image" />
            </div>
          );
        } else {
          return (
            <div className="score_type_container">
              {[...new Array(player_cards[card_type])].map(() =>
                set_image(card_type)
              )}
            </div>
          );
        }
      })
    );
  };

  return (
    <>
      <div className="ct-game-sidebar">
        <div className="gamer-information">
          {allPlayers &&
            allPlayers.length > 0 &&
            allPlayers.map((user) => {
              return (
                <>
                  {user.player_id === active_player && (
                    <div>
                      <div className="gamer-header">
                        <img
                          src={user.profile_image}
                          alt="User"
                          className={`avatar-img ${
                            colours[user.player_id - 1]
                          }`}
                        />
                        <p className="mb-0">
                          {user.display_name.length <= 15
                            ? user.display_name
                            : user.display_name.substring(0, 15) + "..."}
                        </p>
                      </div>
                      <div className="gamer-content">
                        <table className="w-100">
                          {card.map((item) => {
                            return (
                              <tr>
                                <th>{_.get(categoryParams, item)}</th>
                                {[...Array(active_player_cards[item])].map(
                                  () => (
                                    <td>{set_image(item)}</td>
                                  )
                                )}
                                {[...Array(3 - active_player_cards[item])].map(
                                  () => {
                                    return (
                                      <td>
                                        <img src={Cross} alt="" />
                                      </td>
                                    );
                                  }
                                )}
                              </tr>
                            );
                          })}
                          {/* </>
                            );
                          })} */}
                        </table>
                      </div>
                    </div>
                  )}
                </>
              );
            })}

          <div className="gamer-info-list-wrapper">
            {player_queue &&
              player_queue.length > 0 &&
              player_queue.map(
                (player_queue_user_id) =>
                  allPlayers &&
                  allPlayers.length > 0 &&
                  allPlayers.map((user) => (
                    <>
                      {player_queue_user_id === user.player_id && (
                        <div className="gamer-info-list-content">
                          <div className="gamer-info-list">
                            <div className="d-flex align-items-center">
                              <img
                                src={user.profile_image}
                                alt="User"
                                className={`avatar-img ${
                                  colours[user.player_id - 1]
                                }`}
                              />
                              <p className="mb-0">{user.display_name}</p>
                            </div>
                            <div className="nc-scores">
                              {user.player_id === reader && (
                                <span>
                                  <img src={Speaker} alt="Speaker" />
                                </span>
                              )}

                              <div className="score-wrapper">
                                {user &&
                                  render_score_dots(user)?.map((val) => val)}
                              </div>
                            </div>
                          </div>
                          <button
                            className="cancel-btn"
                            onClick={() => {
                              props.delPlayer(user);
                            }}
                          >
                            <i className="fas fa-times" />
                          </button>
                        </div>
                      )}
                    </>
                  ))
              )}
          </div>
        </div>

        <button
          className="times-up-btn"
          onClick={() => {
            props.onTimesUp();
          }}
        >
          {_.get(playingParams, "times_up")}
        </button>
        <button
          className="end-game-btn"
          onClick={() => {
            props.onEndGame();
          }}
        >
          {_.get(playingParams, "end_game")}
        </button>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(CTLeftContent);
